// import React, { useEffect, useState } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import axios from "axios";
// import { API_BASE_URL } from "../../../../utils/index";
// import { useAuthHeaders } from "../../../../components/Token";
// import Swal from 'sweetalert2/dist/sweetalert2.js'
// import CancelButton from "../../../../components/MinorComponents/CancelButton";

// function EditCategory() {
//   const { _id } = useParams();
//   const [newCategoryName, setNewCategoryName] = useState("");
//   const navigate = useNavigate();
//   const headers = useAuthHeaders();

//   useEffect(() => {
//     axios
//       .get(`${API_BASE_URL}/category/admin/getsinglecategory/${_id}`)
//       .then((response) => {
//         setNewCategoryName(response.data.category.name);
//       })
//       .catch((error) => {
//         console.error("Error fetching category:", error);
//       });
//   }, []);

//   const handleSave = (e) => {
//     e.preventDefault();
//     const data = { name: newCategoryName };

//     axios
//       .put(`${API_BASE_URL}/category/admin/updatecategory/${_id}`, data, {
//         headers,
//       })
//       .then((response) => {
//         console.log("response :", response);
//         Swal.fire({
//           icon: "success",
//           title: "Edit Category has been saved",
//           showConfirmButton: false,
//           timer: 1500,
//         });
//         navigate("/category");
//       })
//       .catch((error) => {
//         console.error("Error updating category:", error);
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: error.response.data.error,
//         });
//       });
//   };

//   return (
//     <div className="p-3">
//       <h2>Edit Category</h2>
//       <form onSubmit={handleSave} className="category" style={{boxShadow: "0 0 10px 0 rgba(0,0,0,0.45) inset"}}>
//         <div>
//           <label htmlFor="name" className="fs-6">
//             Change Category Name:
//           </label>
//           <br />
//           <input
//             type="text"
//             id="name"
//             value={newCategoryName}
//             onChange={(e) => setNewCategoryName(e.target.value)}
//           />
//         </div>
//         <div className="buttons">
//           <button type="submit" style={{ backgroundColor: "#0443C0", color: "white" }}>Save</button>

//           <CancelButton path="/category" />
//         </div>
//       </form>
//     </div>
//   );
// }

// export default EditCategory;


import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  Snackbar,
  Alert,
  Paper,
  CircularProgress,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
// import { API_BASE_URL } from "../../../../../utils/index";
import { useAuthHeaders } from "../../../../../components/Token";
import { GETSingleCategory, UpdateCatgoryVendor } from "../../../../../services/api/Category";


function EditVendorCategory() {
  const { _id } = useParams();
  const [newCategoryName, setNewCategoryName] = useState("");
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
  const [loading, setLoading] = useState(false);
  const subdomain = localStorage.getItem("vendorsubdomain");
  const navigate = useNavigate();
  const headers = useAuthHeaders();
  console.log(_id, "_id")

  useEffect(() => {
    // axios
    //   .get(`${API_BASE_URL}/category/admin/getsinglecategory/${_id}`)
    //   .then((response) => {
    //     setNewCategoryName(response.data.category.name);
    //   })
    //   .catch((error) => {
    //     console.error("Error fetching category:", error);
    //     setSnackbar({ open: true, message: "Failed to load category", severity: "error" });
    //   });
    const fetchData = async () => {
      try {

        const response = await GETSingleCategory(subdomain, _id)
        console.log(response, "response")
        if (response.success) {
          setNewCategoryName(response.category.name);
        }
      } catch (error) {
        setSnackbar({ open: true, message: "Failed to load category", severity: "error" });
      }
    }
    fetchData()
  }, [_id]);

  const handleSave = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const data = { name: newCategoryName };


      const response = await UpdateCatgoryVendor(subdomain, data, _id)
      if (response.success) {

        setSnackbar({
          open: true,
          message: "Category updated successfully!",
          severity: "success",
        });
        navigate(`/${subdomain}/master/category`)
      } else {
        // console.error("Error updating category:", errFor);
        setSnackbar({
          open: true,
          message: response?.data?.error || "Failed to update",
          severity: "error",
        });
      }
    } catch (error) {
      console.error("Error updating category:", error);
      setSnackbar({
        open: true,
        message: error?.response?.data?.error || "Failed to update",
        severity: "error",
      });
    }
    finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate(`/${subdomain}/master/category`)
  };

  return (
    <Box p={3}>
      <Typography variant="h5" gutterBottom>
        Edit Category
      </Typography>

      <Paper elevation={3} sx={{ p: 3, maxWidth: 500 }}>
        <form onSubmit={handleSave}>
          <TextField
            fullWidth
            label="Category Name"
            variant="outlined"
            value={newCategoryName}
            onChange={(e) => setNewCategoryName(e.target.value)}
            required
            sx={{ mb: 3 }}
          />

          <Box display="flex" gap={2}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              disabled={loading}
              startIcon={loading && <CircularProgress size={20} color="inherit" />}
            >
              {loading ? "Saving..." : "Save"}
            </Button>

            <Button variant="contained" color="error" onClick={handleCancel}>
              Cancel
            </Button>
          </Box>
        </form>
      </Paper>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
}

export default EditVendorCategory;
